<template>
  <div class="calendar-container">
    <h5 class="headline" v-if="heading">{{ heading }}</h5>
    <div class="calendar-heading">
      <div class="calendar-heading-button-group">
        <round-button-with-icon
          class="icon"
          @click="yearChange(`backward`)"
          icon="left-arrow-double"
        />
        <round-button-with-icon
          class="icon"
          @click="monthChange(`backward`)"
          icon="left-arrow-single"
        />
      </div>
      <h5 class="month-heading">
        {{ monthArray[viewedMonth.getMonth()] }},
        {{ viewedMonth.getFullYear() }}
      </h5>
      <div class="calendar-heading-button-group">
        <round-button-with-icon
          class="icon"
          icon="right-arrow-single"
          @click="monthChange(`forward`)"
        />
        <round-button-with-icon
          class="icon"
          icon="right-arrow-double"
          @click="yearChange(`forward`)"
        />
      </div>
    </div>
    <div class="main-calendar-content">
      <div v-for="(day, index) in WEEKDAYS" class="weekday" :key="index">
        {{ day }}
      </div>
      <div
        v-for="(day, index) in days"
        :key="index"
        :class="{
          day,
          isNotCurrentMonth: !day.isCurrentMonth,
          today: day.isChosenDay,
        }"
        @click="dateChosen(day.date)"
      >
        <p>{{ day.dayOfMonth }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import RoundButtonWithIcon from "../UI/RoundButtonWithIcon.vue";
import {
  nextMonthDays,
  previousMonthDays,
  currentMonthDays,
} from "../../Helpers/calendar.js";

export default {
  data() {
    return {
      WEEKDAYS: ["S", "M", "T", "W", "T", "F", "S"],
      monthArray: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      floatingMenuOpen: false,
      singleDayChosen: undefined,
      month: new Date().getMonth(),
      year: new Date().getFullYear(),
    };
  },

  methods: {
    toggleFloatingMenu() {
      this.floatingMenuOpen = !this.floatingMenuOpen;
    },
    monthChange(direction) {
      if (direction == `forward`) {
        this.month++;
      }
      if (direction == `backward`) {
        this.month--;
      }
    },
    yearChange(direction) {
      if (direction == `forward`) {
        this.year++;
      }
      if (direction == `backward`) {
        this.year--;
      }
    },
    newTimeframeSelected(selections) {
      if (selections.left !== undefined) {
        this.year = selections.left;
      }
      if (selections.right !== undefined) {
        this.month = selections.right;
      }
      this.floatingMenuOpen = false;
    },
    dateChosen(date) {
      this.$emit("dateChosen", date);
    },
  },
  computed: {
    viewedMonth() {
      return new Date(this.year, this.month);
    },
    currentMonthDays() {
      return currentMonthDays(this.viewedMonth, this.chosenDate).map((x) => {
        return {
          ...x,
        };
      });
    },
    days() {
      return [
        ...previousMonthDays(this.viewedMonth),
        ...this.currentMonthDays,
        ...nextMonthDays(this.viewedMonth),
      ];
    },
  },
  emits: ["actionsClicked", "dateChosen"],
  props: ["events", "chosenDate", "heading"],
  components: {
    RoundButtonWithIcon,
  },
  created() {
    if (this.chosenDate) {
      let date = new Date(this.chosenDate);
      this.month = date.getMonth();
      this.year = date.getFullYear();
    }
  },
};
</script>

<style scoped>
.calendar-container {
  display: flex;
  flex-direction: column;
  /* min-width: 290px; */
}

.calendar-heading {
  display: flex;
  justify-content: space-between;
}

.calendar-heading-button-group {
  display: flex;
  align-items: center;
}
.main-calendar-content {
  width: 100%;
  min-height: 306px;
  flex: 1;
  display: grid;
  align-content: space-between;
  justify-content: space-between;
  grid-template-columns: repeat(7, 1fr);
  grid-template-rows: repeat(auto-fill, 1fr);
  cursor: default;
}

.headline {
  margin: 0;
}

.main-calendar-content div {
  /* flex: 1; */
  font-size: 12px;
  margin: 10%;
  /* margin: auto; */
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hasEvents {
  background: radial-gradient(
    circle at center,
    var(--accentColor) 0%,
    var(--accentColor) 40%,
    var(--contrastColor) 43%,
    rgba(0, 0, 0, 0) 44%
  );
  cursor: pointer;
}

.isNotCurrentMonth {
  opacity: 0.25;
}

.icon {
  margin: 10px;
}

.today {
  background: radial-gradient(
    circle at center,
    var(--contrastColor) 0%,
    var(--contrastColor) 43%,
    rgba(0, 0, 0, 0) 44%
  );
}

.today > * {
  filter: invert(100%);
}
</style>
